import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import { PATHS } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  startLoading,
  stopLoading,
  startFormLoading,
  stopFormLoading,
} from './loader';
import { setValidation } from './validation';
import { fetchSuiteUsers } from './suites';
import {
  fetchPropertyManagersByPropertyId,
  fetchPropertyById,
  fetchCountsDone,
} from './properties';

const fetchContactsDone = (payload) => ({
  type: TYPES.FETCH_CONTACTS_DONE,
  payload,
});

export const fetchContacts = (id, role) => (dispatch) => {
  dispatch(startLoading());
  return client
    .getContacts(id, role)
    .then((response) => {
      dispatch(stopLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          dispatch(fetchContactsDone(responsejson));
          dispatch(stopLoading());
        });
      } else {
        dispatch(stopLoading());
      }
    })
    .catch(() => {
      dispatch(stopLoading());
    });
};

const fetchContactServiceRequestsDone = (payload) => ({
  type: TYPES.FETCH_CONTACT_SERVICE_REQUESTS_DONE,
  payload,
});

export const fetchContactServiceRequests = (id, query) => (dispatch) => {
  return client
    .getContactServiceRequests(id, query)
    .then((response) =>
      dispatch(
        fetchContactServiceRequestsDone({ id, serviceRequests: response.data })
      )
    );
};

const saveContactDone = (payload) => ({
  type: TYPES.SAVE_CONTACT_DONE,
  payload,
});

const deleteContactDone = (payload) => ({
  type: TYPES.DELETE_CONTACT_DONE,
  payload,
});
export const deleteContactById =
  (contactId, history, propertyId) => (dispatch) => {
    dispatch(startFormLoading());

    return client.deleteContactById(contactId).then((response) => {
      dispatch(stopFormLoading());

      if (response.ok || response.status === 200) {
        dispatch(deleteContactDone(contactId));

        if (history && history !== 'FromPropertyDeveloper') {
          history.push(PATHS.CONTACTS_LIST);
        } else {
          dispatch(fetchPropertyById(propertyId));
        }
        toast.success(' ⓘ The user has been deleted.', {
          autoClose: 10000,
          position: 'top-center',
        });
      } else {
        toast.error(
          '🚫 Something went wrong with deleting a contact, please try again.',
          {
            autoClose: 12000,
            position: 'top-center',
          }
        );
      }
    });
  };

export const saveContact = (contact, type, actionType) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .saveContact(contact)
    .then((response) => {
      dispatch(stopFormLoading());

      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (
            responsejson.statusCode === 400 ||
            responsejson.statusCode === 409
          ) {
            dispatch(setValidation('Contact'));
            toast.error(' 🚫 This contact already exists !', {
              autoClose: 12000,
              position: 'top-center',
            });
          } else if (responsejson.statusCode === 200) {
            dispatch(setValidation('Contact'));

            if (
              responsejson &&
              responsejson.data &&
              responsejson.data.calendlyInvitation &&
              responsejson.data.calendlyInvitation.statusCodes === '400'
            ) {
              toast.success(
                ' ⓘ Please upgrade your Calendly account to send more invitations.',
                {
                  autoClose: 10000,
                  position: 'top-center',
                }
              );
            } else {
              toast.success(' ⓘ Contact has been added.', {
                autoClose: 10000,
                position: 'top-center',
              });
            }
            dispatch(saveContactDone(responsejson.data));

            if (type === 'suiteUser') {
              dispatch(
                fetchSuiteUsers(
                  responsejson.data.suiteId,
                  actionType === 'saveAndAdd' ? false : true
                )
              );
            }

            if (type === 'FromPropertyDeveloper') {
              dispatch(fetchPropertyManagersByPropertyId(contact.PropertyId));
              dispatch(fetchPropertyById(contact.PropertyId));
            }
            let id = localStorage.getItem('userId');
            let role = localStorage.getItem('rolename');
            dispatch(startLoading());
            return client
              .getContacts(id, role)
              .then((response) => {
                dispatch(stopLoading());

                if (response.ok || response.status === 200) {
                  response.json().then((responsejson) => {
                    dispatch(fetchContactsDone(responsejson));
                    dispatch(stopLoading());
                  });
                } else {
                  dispatch(stopLoading());
                }
              })
              .catch(() => {
                dispatch(stopLoading());
              });
          } else {
            dispatch(setValidation('Contact'));
            toast.success(' 🚫 Contact adding failed.', {
              autoClose: 10000,
              position: 'top-center',
            });
          }
        });
      } else {
        toast.error(
          ' 🚫 Something went wrong with adding a contact or please verify your email format, please try again.',
          {
            autoClose: 14000,
            position: 'top-center',
          }
        );
      }
    })
    .catch((error) => {
      dispatch(stopFormLoading());
      toast.error(
        ' 🚫 Something went wrong with adding a contact, please try again.',
        {
          autoClose: 12000,
          position: 'top-center',
        }
      );
    });
};

const updateContactDone = (payload) => ({
  type: TYPES.UPDATE_CONTACT_DONE,
  payload,
});
const updateSuiteContactDone = (payload) => ({
  type: TYPES.UPDATE_SUITE_CONTACT_DONE,
  payload,
});
export const updateContact = (contact, history, type) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .updateContact(contact)
    .then((response) => {
      dispatch(stopFormLoading());

      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.statusCode === 200) {
            if (
              responsejson &&
              responsejson.data &&
              responsejson.data.calendlyInvitation &&
              responsejson.data.calendlyInvitation.statusCodes === '400'
            ) {
              toast.success(
                ' ⓘ Please upgrade your Calendly account to send more invitations.',
                {
                  autoClose: 10000,
                  position: 'top-center',
                }
              );
            } else {
              toast.success('ⓘ  Contact has been updated.', {
                autoClose: 10000,
                position: 'top-center',
              });
            }
            dispatch(setValidation('Contact'));
            dispatch(updateContactDone(responsejson.data));

            if (type === 'suiteUser') {
              if (responsejson.data.isPrimaryContact === true) {
                dispatch(fetchSuiteUsers(responsejson.data.suiteId));
              } else {
                dispatch(updateSuiteContactDone(responsejson.data));
              }
            }

            if (history && history !== 'FromPropertyDeveloper') {
              history.push(PATHS.CONTACTS_LIST);
            }

            if (history === 'FromPropertyDeveloper') {
              dispatch(fetchPropertyManagersByPropertyId(contact.PropertyId));
              dispatch(fetchPropertyById(contact.PropertyId));
            }
            let id = localStorage.getItem('userId');
            let role = localStorage.getItem('rolename');
            dispatch(startLoading());
            return client
              .getContacts(id, role)
              .then((response) => {
                dispatch(stopLoading());
                if (response.ok || response.status === 200) {
                  response.json().then((responsejson) => {
                    dispatch(fetchContactsDone(responsejson));
                    dispatch(stopLoading());
                  });
                } else {
                  dispatch(stopLoading());
                }
              })
              .catch(() => {
                dispatch(stopLoading());
              });
          } else {
            toast.error('🚫 Contact update failed.', {
              autoClose: 12000,
              position: 'top-center',
            });
          }
        });
      } else {
        toast.error('🚫 Contact update failed.', {
          autoClose: 12000,
          position: 'top-center',
        });
      }
    })
    .catch((error) => {
      dispatch(stopFormLoading());
      toast.error(
        '🚫 Something went wrong with adding a contact, please try again.',
        {
          autoClose: 12000,
          position: 'top-center',
        }
      );
    });
};
export const sendInvitationToContact = (params) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .sendInvitationToContact(params)
    .then((response) => {
      dispatch(stopFormLoading());

      if (response.status === 200 || response.ok) {
        response.json().then((responsejson) => {
          toast.success('Selected users will receive invitations shortly.', {
            autoClose: 10000,
            position: 'top-center',
          });
        });
      } else {
        toast.error(
          '🚫 Something went wrong with sending activation links to users, please try again.',
          {
            autoClose: 12000,
            position: 'top-center',
          }
        );
      }
    })
    .catch(() => {
      dispatch(stopFormLoading());
      toast.error(
        '🚫 Something went wrong with sending activation links to users, please try again.',
        {
          autoClose: 12000,
          position: 'top-center',
        }
      );
    });
};
const saveContactNoteDone = (payload) => ({
  type: TYPES.SAVE_CONTACT_NOTE_DONE,
  payload,
});

export const saveContactNote =
  ({ id, note }) =>
  (dispatch) => {
    return new Promise((resolve) =>
      resolve({
        data: {
          ...note,
          id: 1,
          author: { first_name: 'Jim', last_name: 'banes' },
        },
      })
    ).then((response) =>
      dispatch(saveContactNoteDone({ id, note: response.data }))
    );
  };

export const onEventScheduled = (params) => (dispatch) => {
  return client.onEventScheduled(params).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        toast.success('Event Scheduled successfully.', {
          autoClose: 10000,
          position: 'top-center',
        });
      });
    }
  });
};

export const fetchContactCounts = (contactId, role) => (dispatch) => {
  let loginUserId = null,
    loginUserRole = null;
  const userDetails = JSON.parse(localStorage.getItem('user'));

  if (!!userDetails) {
    loginUserId = userDetails.id;
    loginUserRole = userDetails.roles[0].role.name;
  }

  return client
    .fetchContactCounts(contactId, role, loginUserId, loginUserRole)
    .then((response) => {
      if (response.status === 200 || response.ok) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            dispatch(fetchCountsDone(responsejson.data));
          }
        });
      }
    });
};

export const deletePropertyDeveloper =
  (contactId, propertyId) => (dispatch) => {
    dispatch(startFormLoading());
    return client
      .deletePropertyDeveloper(contactId, propertyId)
      .then((response) => {
        dispatch(stopFormLoading());
        if (response.ok || response.status === 200) {
          dispatch(fetchPropertyById(propertyId));
          toast.success(' ⓘ The user has been deleted.', {
            autoClose: 10000,
            position: 'top-center',
          });
        } else {
          toast.error(
            '🚫 Something went wrong with deleting a contact, please try again.',
            {
              autoClose: 12000,
              position: 'top-center',
            }
          );
        }
      })
      .catch(() => {
        toast.error('🚫 Something went wrong., please try again.', {
          autoClose: 12000,
          position: 'top-center',
        });
      });
  };

export const fetchServiceProviders = (issueType) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .getServiceProviders(issueType)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          dispatch(fetchSuiteUsersDone(responsejson));
        });
      } else {
        dispatch(stopFormLoading());
        dispatch(fetchSuiteUsersDone([]));
      }
    })
    .catch(() => {
      dispatch(stopFormLoading());
      dispatch(fetchSuiteUsersDone([]));
    });
};

const fetchSuiteUsersDone = (payload) => ({
  type: TYPES.FETCH_SUITE_USERS_LIST,
  payload,
});
